import React, { useEffect, useState } from "react";
import Logo from "./Logo";

export default function AgeGate() {
    const [visible, setVisible] = useState(false);
    const [confirmed, setConfirmed] = useState(false);

    useEffect(() => {
        const ok = localStorage.getItem("veloura_age_ok");
        if (!ok) setVisible(true);
    }, []);

    const confirm = () => {
        localStorage.setItem("veloura_age_ok", "1");
        setConfirmed(true);
        setTimeout(() => setVisible(false), 380);
    };

    const deny = () => {
        window.location.href = "https://www.google.com";
    };

    if (!visible) return null;

    return (
        <div
            data-testid="age-gate-modal"
            className="fixed inset-0 z-[100] flex items-center justify-center"
            style={{
                background: "rgba(6,6,7,0.97)",
                backdropFilter: "blur(28px) saturate(1.1)",
                WebkitBackdropFilter: "blur(28px) saturate(1.1)",
                opacity: confirmed ? 0 : 1,
                transition: "opacity 380ms ease",
            }}
        >
            <div className="vl-grain absolute inset-0 opacity-60" />
            <div className="relative max-w-[640px] w-[92%] text-center px-4">
                <div
                    className="flex justify-center mb-2"
                    data-testid="age-gate-brand"
                >
                    <Logo size="lg" variant="plate" testId="age-gate-logo" />
                </div>
                <div
                    className="overline mb-10"
                    style={{ color: "var(--vl-rose)" }}
                >
                    Intimate Wellness · Private Access
                </div>
                <h1
                    className="font-serif leading-[0.96] tracking-tight mb-7"
                    style={{
                        color: "var(--vl-text)",
                        fontSize: "clamp(38px, 6vw, 76px)",
                    }}
                >
                    This boutique is for{" "}
                    <em
                        style={{
                            color: "var(--vl-rose)",
                            fontStyle: "italic",
                        }}
                    >
                        adults.
                    </em>
                </h1>
                <p
                    className="text-sm sm:text-base mb-10 max-w-md mx-auto"
                    style={{
                        color: "var(--vl-muted)",
                        lineHeight: 1.85,
                    }}
                >
                    Veloura Wellness is a premium intimate wellness
                    boutique. By continuing, you confirm you are 18 years
                    of age or older and wish to browse our collection.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        data-testid="age-gate-confirm"
                        className="vl-btn vl-btn-solid"
                        onClick={confirm}
                    >
                        I am 18 or older
                    </button>
                    <button
                        data-testid="age-gate-deny"
                        className="vl-btn vl-btn-ghost"
                        onClick={deny}
                    >
                        I am under 18
                    </button>
                </div>

                <div
                    className="mt-14 flex items-center justify-center gap-6 text-[11px] tracking-[0.22em] uppercase"
                    style={{ color: "var(--vl-muted)" }}
                >
                    <span>Discreet shipping</span>
                    <span
                        style={{
                            width: 6,
                            height: 6,
                            borderRadius: 999,
                            background: "var(--vl-rose)",
                        }}
                    />
                    <span>Private checkout</span>
                    <span
                        style={{
                            width: 6,
                            height: 6,
                            borderRadius: 999,
                            background: "var(--vl-rose)",
                        }}
                    />
                    <span>Dermatologist-tested</span>
                </div>
            </div>
        </div>
    );
}
